import {
  Color,
  Header,
  Paragraph
} from '@eggplant/pattern-library'
import { LinkToTestManagementToolsDoc } from '../links'

const IntegrationSettings = () =>
  <div className='grid gap-4'>
    <div className='grid gap-3'>
      <Header
        hasNoTopMargin
        lessWeight
        rank={3}
      >
        Integration settings
      </Header>
      <Paragraph>
        <strong>
          <Color variant='theme-description-text'>
            Enter the connection details for your chosen test management tool. The fields may vary depending on the tool selected.
          </Color>
        </strong>
      </Paragraph>
    </div>
    <Paragraph>
      <LinkToTestManagementToolsDoc />
    </Paragraph>
  </div>

export default IntegrationSettings
